import httpClientService from '@/services/httpClientService';

export default {
	cloneProject: (item) =>
		httpClientService.Post(
			'/ProjectManagementModule/api/CloneProject',
			item
		),
	cloneOptions: (item) =>
		httpClientService.Post(
			'/ProjectManagementModule/api/CloneProject/CloneOptions',
			item
		),
	getClients: () =>
		httpClientService.Get(
			'/ProjectManagementModule/api/CloneProject/GetClients'
		),
	getProjects: (id) =>
		httpClientService.Get(
			'/ProjectManagementModule/api/CloneProject/GetProjects/?clientId=' +
				id
		),
};
